<template>
  <div>
  <div v-if="hasData">
    <b-table
      class="table-with-actions-min-height px-2"
      responsive
      small
      show-empty
      :items="alertsFilter"
      :fields="computedTableFields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      @filtered="onFiltered"
    >
        <template #cell(xtendEntities)="row">
          <div>
            <span
              v-for="(entity, index) in row.item.xtendEntities"
              :key="entity.id"
            >
              <b-link :to="`/xtends/${entity.id}`">{{ entity.name }}</b-link>
              <span v-if="index < row.item.xtendEntities.length - 1">, </span>
            </span>
          </div>
        </template>
      <template #cell(time)="row">
        {{ formatDate(row.value) }}
      </template>
      <template #cell(msg)="row">
        {{ row.value }}
      </template>
      <template #cell(type)="row">
        {{ row.value }}
      </template>
      <template #cell(severity)="row">
        <b-badge pill :variant="alertStatusVariant(row.value)">
          {{ alertStatusText(row.value)}}
        </b-badge>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="paginationTotalRows"
      :per-page="perPage"
      align="right"
      first-number
      last-number
      prev-class="prev-item"
      next-class="next-item"
      class="mb-2 mx-1"
    />
  </div>
  <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
    {{ $t("No Data Available") }}
  </div>
  </div>
</template>

<script>
import moment from 'moment';
import SecurityEventBus from '@/xvisor/bus/SecurityEventBus';
import momentTimeFormat from '@/xvisor/constants/momentTimeFormat';
import alertSeverities from '@/xvisor/constants/alertSeverities';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      default: null,
    },
    filter: {
      type: String,
      default: '',
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      alerts: [],
      loaded: false,
      currentPage: 1,
      sortDesc: true,
      sortBy: 'time',
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filteredLength: null,
      tableFields: [
        { key: 'xtendEntities', label: 'Endpoint(s)', sortable: true },
        { key: 'time', label: 'Time', sortable: true },
        { key: 'msg', label: 'Message', sortable: true },
        { key: 'type', label: 'Type', sortable: true },
        { key: 'severity', label: 'Severity', sortable: true },
      ],
      selected: [],
    };
  },
  computed: {
    hasData() {
      return this.loaded && this.alerts && this.alerts.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.alerts.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    alertsFilter() {
      const retVal = this.alerts;
      return retVal;
    },
  },
  watch: {
    url() {
      if (!this.items) this.httpGet();
    },
    timeRange() {
      if (!this.items) this.httpGet();
    },
    selected() {
      SecurityEventBus.$emit('update-selected-alert', this.selected[0]);
    },
    items: {
      immediate: true,
      handler(val) {
        if (Array.isArray(val)) {
          this.alerts = val;
          this.loaded = true;
          this.$emit('total-rows', this.alerts.length);
        }
      },
    },
  },
  mounted() {
    if (!this.items) this.httpGet();
  },
  methods: {
    alertStatusVariant(status) {
      if (status === alertSeverities.critical) return 'danger';
      if (status === alertSeverities.warning) return 'warning';
      return 'success';
    },
    alertStatusText(status) {
      if (status === alertSeverities.critical) return 'Critical';
      if (status === alertSeverities.warning) return 'Warning';
      return 'Notice';
    },
    formatDate(dateStr) {
      return moment(dateStr).format(momentTimeFormat.dateYearTime);
    },
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => {
          this.alerts = response.data;
          this.$emit('total-rows', Array.isArray(this.alerts) ? this.alerts.length : 0);
        })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.$emit('filtered-length', filteredItems.length);
      this.filteredLength = filteredItems.length;
    },
  },
};
</script>

<style scoped>
  .form-select{
      min-width: 160px;
      width: 20%;
  }
</style>
